import React from 'react';
import FlightScheduleLegs from './FlightScheduleLegs';

/**
 * Manual assignment uses the canonical route list in multi-select mode. This
 * wrapper intentionally owns only the mode configuration so route presentation
 * stays identical to auto assignment and the generated-route preview.
 */
const FlightManualScheduleLegs = (props) => (
    <FlightScheduleLegs selectedLegs={[0]} {...props} selectionMode="multiple"/>
);

export default FlightManualScheduleLegs
